import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled, { StyledFunction } from 'styled-components';
import { IStore } from '../../domain/store/IStore';

interface IProps {
  store?: IStore;
}

const StyledDiv: StyledFunction<{ show: boolean } & React.HTMLProps<HTMLInputElement>> = styled.div;
const Wrapper = StyledDiv`
  display: ${props => (props.show ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  margin-top: 5vh;

  p {
    font-size: 1.230769231rem;
    margin-bottom: 36px;
  }

`;

@inject('store')
@observer
export default class ErrorScreen extends React.Component<IProps, {}> {
  private store: IStore;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
  }

  private html() {
    return { __html: this.store.uiState.error.message };
  }

  public render() {
    const { uiState } = this.store;
    return (
      <Wrapper show={uiState.hasError}>
        <h1>{uiState.error.title}</h1>
        <p dangerouslySetInnerHTML={this.html()} />
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/ErrorScreen.tsx